module.exports = __webpack_public_path__ + "img/about-辅导项目-中级职称（护理）类.48407e6f.jpg";